import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { prepareKanboardProgressBar } from '../actions';
import { selectKanbanBoardProgressBarValue } from '../selectors';

const COLOR_GREEN = '#0BCF97';
const COLOR_ORANGE = '#FC9629';
const COLOR_RED = '#D50046';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class ProgressBarAdvertisementComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch();
  }

  render() {
    
    return (
      <Container className="ProgressBarAdvertisement" style={{ height: `${this.props.height || 4}px` }}>
        {this.renderBar()}
      </Container>
    );
  }

  renderBar() {
    let p = this.props.progressAdvertisement;
    if (p === undefined) return <Bar progressAdvertisement={-1} height={this.props.height} width={this.props.width} />;
    if (p == -1) return <Bar progressAdvertisement={1} height={this.props.height} width={this.props.width} />;
    return <Bar progressAdvertisement={p} height={this.props.height} width={this.props.width} />;
  }
}

ProgressBarAdvertisementComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};


function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      //dispatch(prepareKanboardProgressBar(ownProps.type, ownProps.target, ownProps.boardId));
    },
  };
}

const withConnect = connect(
  mapDispatchToProps,
);

export const ProgressBarAdvertisement = compose(
  withConnect,
  withRouter,
)(ProgressBarAdvertisementComp);

function Bar(props) {
  const maxWidth = props.width || 127;
  let innerWidth = Math.ceil((props.progressAdvertisement || 0) * maxWidth);

  if (props.progressAdvertisement !== undefined) innerWidth = Math.max(innerWidth, 5);

  let color = COLOR_GREEN;

  const height = props.height || 4;

  const COLORS = [
    '#00BFAE', '#24B99B', '#48B388', '#6CAD75', '#90A862',
    '#B4A24F', '#D89C3C', '#FC9629', '#F78C2E', '#F28334',
    '#ED7939', '#E8703F', '#E36644', '#DE5D4A', '#D9534F'
  ];
  
  function getColorForProgress(progressAdvertisement) {
    if (progressAdvertisement === -1) return '#eff2f7'; // Special case for -1
    if (progressAdvertisement >= 0.95) return COLORS[0]; // Near green for high values
  
    // Calculate index in COLORS array based on progressAdvertisement
    const index = Math.min(
      Math.floor(progressAdvertisement * 15), // Scale up to get index in 15-color gradient
      COLORS.length - 1                       // Ensure index does not exceed array length
    );
    
    return COLORS[COLORS.length - 1 - index]; // Reverse to start from red at 0
  }
  
  // Usage Example
  color = getColorForProgress(props.progressAdvertisement);
  
  return (
    <div
      style={{
        width: `${maxWidth}px`,
        backgroundColor: '#eff2f7',
        height: height + 'px',
        display: 'inline-block',
        borderRadius: Math.floor(height / 2) + 'px',
        overflow: 'hidden',
        position: 'absolute',
      }}
    >
      <div
        style={{
          width: innerWidth + 'px',
          backgroundColor: color,
          height: height + 'px',
          display: 'inline-block',
          borderRadius: Math.floor(height / 2) + 'px',
          overflow: 'hidden',
          position: 'absolute',
        }}
      ></div>
    </div>
  );
}
